
export default function BasicSpecs() {
  const specs = [
    { label: 'カード名', value: '大手ECモール系カード' },
    { label: '年会費', value: '永年無料' },
    { label: 'ポイント還元率', value: '1.0%（ECモールで3.0%以上）' },
    { label: '国際ブランド', value: 'Visa / Mastercard® / JCB / American Express' },
    { label: '申込条件', value: '満18歳以上（高校生を除く）' },
    { label: '発行スピード', value: '約1週間〜10日' },
    { label: 'ポイント名', value: 'ECモールポイント' },
    { label: 'ポイント有効期限', value: '最後にポイントを獲得した月を含めた1年間（実質無期限）' },
    { label: '電子マネー', value: 'Edy / Apple Pay / Google Pay / スマホ決済' },
    { label: '付帯保険', value: '海外旅行傷害保険（最高2,000万円）※利用付帯' },
    { label: 'ETCカード', value: '年会費550円（税込）※会員ランクがダイヤモンド・プラチナ会員は無料' },
    { label: '家族カード', value: '年会費無料' },
    { label: 'ご利用可能枠', value: '最高100万円' },
    { label: 'カードデザイン', value: '通常デザイン / キャラクターデザイン / その他コラボデザイン多数' },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#333333] mb-8 text-center">
          大手ECモール系カードの基本スペック
        </h2>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <table className="w-full">
            <tbody>
              {specs.map((spec, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-[#FFF5F5]' : 'bg-white'}>
                  <td className="px-6 py-4 text-sm font-bold text-gray-700 border-b border-gray-200 w-1/3">
                    {spec.label}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 border-b border-gray-200">
                    {spec.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
